// extracted by mini-css-extract-plugin
module.exports =  {"links":"b429494557--links--kt1bo","link":"b429494557--link--TWc7K"};